export var ExerciseExecutionPlayerState;
(function (ExerciseExecutionPlayerState) {
    ExerciseExecutionPlayerState["PREVIEW"] = "PREVIEW";
    ExerciseExecutionPlayerState["PLAYING"] = "PLAYING";
    ExerciseExecutionPlayerState["EVAL"] = "EVAL";
})(ExerciseExecutionPlayerState || (ExerciseExecutionPlayerState = {}));
//# sourceMappingURL=exerciseExecutionPlayerState.js.map